var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.collect.status !== "D"
    ? _c(
        "div",
        {
          staticClass: "card",
          class: {
            "associated-collect": _vm.associated,
            confirmed: _vm.collect.confirmation,
          },
        },
        [
          _c(
            "div",
            { staticClass: "card-header centered-items" },
            [
              _vm.collect.fake
                ? _c(
                    "b-tooltip",
                    {
                      staticStyle: { "margin-top": "1rem" },
                      attrs: {
                        label: _vm.$t(
                          "pages.pickup_management.collect_confirmation.templates.hint"
                        ),
                        position: "is-left",
                      },
                    },
                    [
                      _c("b-icon", {
                        staticClass: "is-small",
                        attrs: { icon: "info", type: "is-info" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.collect.fake
                ? _c("div", [
                    _c("h2", { staticClass: "subtitle centered-items" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("pages.pickup_management.calendar.collect")
                          ) +
                          " "
                      ),
                    ]),
                    !_vm.associated
                      ? _c("span", { staticClass: "d-flex-justify-center" }, [
                          _vm._v(_vm._s(_vm.collect.collectId)),
                        ])
                      : _c("span", { staticClass: "d-flex-justify-center" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.collect.enduserCode +
                                  " - " +
                                  _vm.collect.enduserName
                              )
                          ),
                        ]),
                  ])
                : _vm._e(),
              !_vm.informative
                ? _c(
                    "span",
                    { staticClass: "top-right-button" },
                    [
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            label: _vm.$t(
                              "pages.pickup_management.calendar.send_collect_confirmation"
                            ),
                            position: "is-top",
                          },
                        },
                        [
                          (_vm.collect.newStatus === "T1" ||
                            _vm.collect.newStatus === "T2") &&
                          !_vm.collect.confirmation
                            ? _c("b-button", {
                                staticClass: "is-primary is-small",
                                attrs: { "icon-left": "paper-plane" },
                                on: {
                                  click: function ($event) {
                                    return _vm.collectConfirmation(_vm.collect)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "card-content" }, [
            _vm.collect.fake
              ? _c("span", [
                  _c("span", { staticClass: "row-label" }, [
                    _vm._v(" " + _vm._s(_vm.$t("global.enduser")) + " : "),
                  ]),
                  _vm._v(" enduser_field "),
                ])
              : _vm._e(),
            _c("span", [
              _c("span", { staticClass: "row-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("pages.pickup_management.calendar.loading_date")
                    ) +
                    " : "
                ),
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    !_vm.collect.fake
                      ? _vm.collect.loadingDate
                        ? _vm
                            .$dayjs(_vm.collect.loadingDate)
                            .format("DD-MM-YYYY")
                        : ""
                      : _vm.collect.loadingDate
                  ) +
                  " "
              ),
            ]),
            _c("span", [
              _c("span", { staticClass: "row-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "pages.pickup_management.calendar.infos.arrival_date"
                      )
                    ) +
                    " : "
                ),
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    !_vm.collect.fake
                      ? _vm.collect.arrivalDate &&
                        !_vm.collect.arrivalDate.includes("0000")
                        ? _vm
                            .$dayjs(_vm.collect.arrivalDate)
                            .format("DD-MM-YYYY")
                        : ""
                      : _vm.collect.arrivalDate
                  ) +
                  " "
              ),
            ]),
            _c("span", [
              _c("span", { staticClass: "row-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "pages.pickup_management.calendar.infos.creation_date"
                      )
                    ) +
                    " : "
                ),
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    !_vm.collect.fake
                      ? _vm.collect.creationDate &&
                        !_vm.collect.creationDate.includes("0000")
                        ? _vm
                            .$dayjs(_vm.collect.creationDate)
                            .format("DD-MM-YYYY")
                        : ""
                      : _vm.collect.creationDate
                  ) +
                  " "
              ),
            ]),
            _c("span", [
              _c("span", { staticClass: "row-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "pages.pickup_management.calendar.infos.notification_date"
                      )
                    ) +
                    " : "
                ),
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    !_vm.collect.fake
                      ? _vm.collect.notificationDate &&
                        !_vm.collect.notificationDate.includes("0000")
                        ? _vm
                            .$dayjs(_vm.collect.notificationDate)
                            .format("DD-MM-YYYY")
                        : ""
                      : _vm.collect.notificationDate
                  ) +
                  " "
              ),
            ]),
            _c("span", [
              _c("span", { staticClass: "row-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("pages.pickup_management.calendar.infos.forwarder")
                    ) +
                    " : "
                ),
              ]),
              _vm._v(" " + _vm._s(_vm.collect.forwarderName) + " "),
            ]),
            _c("span", [
              _c("span", { staticClass: "row-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "pages.pickup_management.calendar.infos.shipment_nr"
                      )
                    ) +
                    " : "
                ),
              ]),
              _vm._v(" " + _vm._s(_vm.collect.shipmentNr) + " "),
            ]),
            _c("span", [
              _c("span", { staticClass: "row-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "pages.pickup_management.calendar.infos.destination_code"
                      )
                    ) +
                    " : "
                ),
              ]),
              _vm._v(" " + _vm._s(_vm.collect.destCode) + " "),
            ]),
            _c("span", [
              _c("span", { staticClass: "row-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "pages.pickup_management.calendar.infos.destination"
                      )
                    ) +
                    " : "
                ),
              ]),
              _vm._v(" " + _vm._s(_vm.collect.destName) + " "),
            ]),
            _c("span", [
              _c("span", { staticClass: "row-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "pages.pickup_management.calendar.infos.destination_address"
                      )
                    ) +
                    " : "
                ),
              ]),
              _vm._v(" " + _vm._s(_vm.collect.destAdress) + " "),
            ]),
            !_vm.collect.fake
              ? _c("span", [
                  _c("span", { staticClass: "row-label" }, [
                    _vm._v(" " + _vm._s(_vm.$t("global.status")) + " : "),
                  ]),
                  _c("span", { class: "S" + _vm.collect.newStatus }, [
                    _vm._v(_vm._s(_vm.collect.newStatus)),
                  ]),
                ])
              : _vm._e(),
            _c("span", [
              _c("span", { staticClass: "row-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("pages.pickup_management.calendar.infos.ob_nr")
                    ) +
                    " : "
                ),
              ]),
              _vm._v(" " + _vm._s(_vm.collect.obNr) + " "),
            ]),
            _vm.collect.confirmation
              ? _c("span", [
                  _c("span", { staticClass: "row-label" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "pages.pickup_management.calendar.infos.confirmation"
                          )
                        ) +
                        " : "
                    ),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        this.$dayjs(_vm.collect.confirmation.createdAt).format(
                          "DD/MM/YYYY"
                        )
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            !_vm.collect.fake
              ? _c("span", [
                  _c("span", { staticClass: "row-label" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "pages.pickup_management.calendar.infos.comment1"
                          )
                        ) +
                        " : "
                    ),
                  ]),
                  _vm._v(" " + _vm._s(_vm.collect.text1) + " "),
                ])
              : _vm._e(),
            !_vm.collect.fake
              ? _c("span", [
                  _c("span", { staticClass: "row-label" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "pages.pickup_management.calendar.infos.comment2"
                          )
                        ) +
                        " : "
                    ),
                  ]),
                  _vm._v(" " + _vm._s(_vm.collect.text2) + " "),
                ])
              : _vm._e(),
            _c("div", { staticClass: "separator" }),
            _vm.collect.fake
              ? _c("div", [
                  _c("b", [
                    _vm._v(" " + _vm._s(_vm.$t("global.materials")) + " : "),
                  ]),
                  _c("span", [_vm._v("materials_field")]),
                ])
              : _c(
                  "div",
                  _vm._l(_vm.collect.materials, function (m) {
                    return _c("div", { key: m.collectId }, [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(m.mat) +
                            " : " +
                            _vm._s(parseInt(m.qty) || m.qty) +
                            " "
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
            _c(
              "div",
              [
                _vm.collect.newStatus === "C"
                  ? _c(
                      "b-button",
                      {
                        staticStyle: { "margin-top": "1rem" },
                        attrs: { type: "is-danger is-small is-fullwidth" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteCollect(_vm.collect.collectId)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("global.delete")) + " ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }